import { Component, OnInit, ViewChild } from '@angular/core';

import {
  ApexChart,
  ApexAxisChartSeries,
  ChartComponent,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexGrid,
  ApexStroke,
  ApexFill,
} from 'ng-apexcharts';
import { GeneralService } from '../services/general.service';
type ApexXAxis = {
  type?: 'category' | 'datetime' | 'numeric';
  categories?: any;
  labels?: {
    style?: {
      colors?: string | string[];
      fontSize?: string;
    };
  };
};
export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  grid: ApexGrid;
  colors: string[];
  legend: ApexLegend;
  stroke: ApexStroke;
  fill: ApexFill;
};

@Component({
  selector: 'app-bureau-etude',
  templateUrl: './bureau-etude.component.html',
  styleUrls: ['./bureau-etude.component.scss'],
})
export class BureauEtudeComponent implements OnInit {
  apiUrl = 'https://srv-msgi.pmc.tn/api/';
  public chartOptions: Partial<ChartOptions>;
  monthsTab = Array(
    'janvier',
    'février',
    'mars',
    'avril',
    'mai',
    'juin',
    'juillet',
    'août',
    'septembre',
    'octobre',
    'novembre',
    'décembre'
  );
  data: any = {
    DEEncours: '',
    listeDe: [],
    listeOF: [],
    listeMC: [],
    DEchartOption: null,
    OFchartOption: null,
    MCchartOption: null,
    nbreOf: [],
    nbreMC: '',
    chartOptionsDE: {},
  };
  constructor(private generalSerice: GeneralService) {
    setInterval(() => {
      this.fetchdata()
    },300*1000);
  }

  ngOnInit(): void {
    this.fetchdata()
  }
  fetchdata()
  {
    this.setupDE();
    this.setupOF();
    this.setupMC();
  }
  async setupOF() {
    this.rechercheTable2('API_NbreOF').subscribe(
      (res: any) => (this.data.nbreOf = res)
    );

    // ? List of demande d'etude

    this.rechercheTable2('API_ListeOF').subscribe((res: any) => {
      res = res.map((e) => {
        const date1: any = new Date(e.OF_Date);
        const date2: any = new Date();
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return {
          ...e,
          color: diffDays < 2 ? 'green' : diffDays > 6 ? 'red' : 'blue',
        };
      });
      res = this.groupBy(res, 'OFParam_Code');
      this.data.listeOF = res;
    });
    //
    let OF: any = await this.rechercheTable2('API_TauxOF').toPromise();
    let OFCROSS: any = await this.rechercheTable2(
      'API_TauxOFCROSS'
    ).toPromise();
    let OFARM: any = await this.rechercheTable2('API_TauxOFARM').toPromise();
    let labels: any = this.groupBy(OF, 'month').map((e) => e[0].month);

    OF = this.groupBy(OF, 'month').map((month: any) => {
      const sem = month.find((t) => t.exp3 == '>sem') || { nbre: 1 };
      const tot = month.find((t) => t.exp3 == 'tot') || { nbre: 1 };
      return this.generalSerice.roundToFixed(
        ((tot.nbre || 0) - (sem.nbre || 0)) / (tot.nbre || 1)
      );
    });
    OFCROSS = this.groupBy(OFCROSS, 'month').map((month: any) => {
      const sem = month.find((t) => t.exp3 == '>sem') || { nbre: 1 };
      const tot = month.find((t) => t.exp3 == 'tot') || { nbre: 1 };
      return this.generalSerice.roundToFixed(
        ((tot.nbre || 0) - (sem.nbre || 0)) / (tot.nbre || 1)
      );
    });
    OFARM = this.groupBy(OFARM, 'month').map((month: any) => {
      const sem = month.find((t) => t.exp3 == '>sem') || { nbre: 1 };
      const tot = month.find((t) => t.exp3 == 'tot') || { nbre: 1 };
      return this.generalSerice.roundToFixed(
        ((tot.nbre || 0) - (sem.nbre || 0)) / (tot.nbre || 1)
      );
    });

    if (labels.length < 3) {
      labels.unshift(labels[0] - 1);
      OF.unshift(0);
      OFCROSS.unshift(0);
      OFARM.unshift(0);
    }

    labels = labels.map((month: any) => this.monthsTab[month - 1]);
    // this.data.OFchartOption = this.setupOptions(OF, labels);
    this.data.OFchartOption = this.ofChart(OF, OFCROSS, OFARM, labels);
  }
  setupDE() {
    // ? Nombre des demande d'etude : HERE
    this.rechercheTable2('API_NbreDEEncours').subscribe(
      (res) => (this.data.DEEncours = res[0].DEEncours)
    );

    // ? List of demande d'etude

    this.rechercheTable2('API_ListeDE').subscribe((res: any) => {
      this.data.listeDe = res.map((e) => {
        const date1: any = new Date(e.Doc_Date);
        const date2: any = new Date();
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return {
          ...e,
          color: diffDays < 2 ? 'green' : diffDays > 6 ? 'red' : 'blue',
        };
      });
    });
    // ? Histogram
    this.rechercheTable2('API_TauxDE').subscribe((res: any) => {
      const vals = this.groupBy(res, 'month').map((month: any) => {
        const sem = month.find((t) => t.exp3 == '>sem') || { nbre: 1 };
        const tot = month.find((t) => t.exp3 == 'tot') || { nbre: 1 };
        return this.generalSerice.roundToFixed(
          ((tot.nbre || 0) - (sem.nbre || 0)) / (tot.nbre || 1)
        );
      });
      let labels: any = this.groupBy(res, 'month').map((e) => e[0].month);
      if (labels.length < 3) {
        labels.unshift(labels[0] - 1);
        vals.unshift(0);
      }
      labels = labels.map((month: any) => this.monthsTab[month - 1]);

      this.data.DEchartOption = this.setupOptions(vals, labels);
    });
  }
  setupMC() {
    this.rechercheTable2('API_NbreMC').subscribe(
      (res) => (this.data.nbreMC = res[0].nbre)
    );

    this.rechercheTable2('API_ListeMC').subscribe((res: any) => {
      this.data.listeMC = res.map((e) => {
        const date1: any = new Date(e.Doc_Date);
        const date2: any = new Date();
        const diffTime = Math.abs(date2 - date1);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return {
          ...e,
          color: diffDays < 2 ? 'green' : diffDays > 6 ? 'red' : 'blue',
        };
      });
    });
    this.rechercheTable2('API_TauxMC').subscribe((res: any) => {
      let vals = this.groupBy(res, 'month').map((month: any) => {
        const sem = month.find((t) => t.exp3 == '>sem') || { nbre: 1 };
        const tot = month.find((t) => t.exp3 == 'tot') || { nbre: 1 };
        return this.generalSerice.roundToFixed(
          ((tot.nbre || 0) - (sem.nbre || 0)) / (tot.nbre || 1)
        );
      });
      let labels: any = this.groupBy(res, 'month').map((e) => e[0].month);

      if (labels.length < 3) {
        labels.unshift(labels[0] - 1);
        vals.unshift(0);
      }
      labels = labels.map((month: any) => this.monthsTab[month - 1]);
      vals = vals.map((v) =>
        this.generalSerice.roundToFixed((v / vals[vals.length - 1]) * 100)
      );
      this.data.MCchartOption = this.setupOptions(vals, labels);
    });
  }
  groupBy(items, key) {
    return Object.values(
      items.reduce(
        (result, item) => ({
          ...result,
          [item[key]]: [...(result[item[key]] || []), item],
        }),
        {}
      )
    );
  }

  setupOptions(vals, labels) {
    return {
      series: [
        {
          name: 'Taux',
          data: vals,
        },
      ],
      tooltip: {
        x: {
          formatter: function (val) {
            return val + ' %';
          },
        },
      },
      chart: {
        height: 350,
        type: 'bar',
        events: {
          click: function (chart, w, e) {
            // console.log(chart, w, e)
          },
        },
      },
      colors: ['#b91c1c', '#047869', '#1d4ed8'],
      plotOptions: {
        bar: {
          columnWidth: '45%',
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      grid: {
        show: false,
      },
      xaxis: {
        categories: labels,
        labels: {
          style: {
            colors: ['#b91c1c', '#047869', '#1d4ed8'],
            fontSize: '12px',
          },
        },
      },
    };
  }
  ofChart(OF, OFCROSS, OFARM, labels) {
    return {
      series: [
        {
          name: 'OF',
          data: OF,
        },
        {
          name: 'OFCROSS',
          data: OFCROSS,
        },
        {
          name: 'OFARM',
          data: OFARM,
        },
      ],
      chart: {
        type: 'bar',
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      xaxis: {
        categories: labels,
      },
      fill: {
        opacity: 1,
      },
    };
  }
  rechercheTable2(tb) {
    return this.generalSerice.customRequest(
      this.apiUrl + 'recherche/tbdata?tablere=' + tb
    );
  }
}
